// components/CarriageFormModal.tsx
import React from "react";
import Modal from "Common/Components/Modal";
import FarmerSelect from "./FarmerSelect";
import VillageSelect from "./VillageSelect";
import CitySelect from "./CitySelect";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
interface CarriageFormModalProps {
  show: boolean;
  isEdit: boolean;
  commitID: any;
  setCommitID: (data: any) => void;
  onHide: () => void;
  onSubmit: (e?: any) => void;
  validation: any;
  selectedFarmer: any;
  selectedVillage: any;
  selectedOrigin: any;
  selectedDestination: any;
  dateValue: any;
  onDateChange: (date: any) => void;
  onFarmerChange: (farmer: any) => void;
  onVillageChange: (village: any) => void;
  onOriginChange: (origin: any) => void;
  onDestinationChange: (destination: any) => void;
}

const CarriageFormModal: React.FC<CarriageFormModalProps> = ({
  show,
  isEdit,
  onHide,
  onSubmit,
  validation,
  selectedFarmer,
  selectedVillage,
  selectedOrigin,
  selectedDestination,
  dateValue,
  onDateChange,
  commitID,
  setCommitID,
  onFarmerChange,
  onVillageChange,
  onOriginChange,
  onDestinationChange,
}) => {
  const formatNumber = (num: number | string) => {
    if (num === null || num === undefined || num === "") return "";
    const numStr = num.toString()?.replace(/,/g, "");
    return numStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const parseFormattedNumber = (formattedNum: string) => {
    return formattedNum?.replace(/,/g, "");
  };
  return (
    <Modal
      show={show}
      onHide={onHide}
      modal-center="true"
      className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
      dialogClassName="w-screen md:w-[50rem] bg-white shadow rounded-md dark:bg-zink-600"
    >
      <Modal.Header
        className="flex items-center justify-between p-4 border-b dark:border-zink-500"
        closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
      >
        <Modal.Title className="text-16">
          {isEdit ? "به روز رسانی اطلاعات" : "ثبت بار های آماده"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
        <form
          className="create-form"
          id="create-form"
          onSubmit={validation.handleSubmit}
        >
          <div className="grid grid-cols-1 items-center md:grid-cols-2 xl:grid-cols-3 gap-4 mr-6">
            <FarmerSelect
              selectedFarmer={selectedFarmer}
              onFarmerChange={onFarmerChange}
              commitID={commitID}
              setCommitID={setCommitID}
              isEdit={isEdit}
            />

            {/* تاریخ بارگیری */}
            <div className="flex flex-col">
              <label className="text-base font-medium mb-2 dark:text-white">
                تاریخ بارگیری:
              </label>
              <DatePicker
                calendar={persian}
                locale={persian_fa}
                value={dateValue}
                onChange={onDateChange}
                format="YYYY/MM/DD"
                calendarPosition="bottom-right"
                containerClassName="w-full"
                inputClass="form-input w-full p-3 border border-gray-300 rounded-lg bg-white text-gray-900 dark:text-white dark:bg-gray-800 dark:border-gray-600 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            <VillageSelect
              selectedVillage={selectedVillage}
              onVillageChange={onVillageChange}
            />

            <CitySelect
              selectedCity={selectedOrigin}
              onCityChange={onOriginChange}
              label="مبدا"
              placeholder="شهر مبدا را انتخاب کنید..."
            />

            <CitySelect
              selectedCity={selectedDestination}
              onCityChange={onDestinationChange}
              label="مقصد"
              placeholder="شهر مقصد را انتخاب کنید..."
            />

            {/* وزن بار */}
            <div className="flex flex-col">
              <label
                htmlFor="weight"
                className="text-base font-medium mb-2 dark:text-white"
              >
                وزن بار (تن):
              </label>
              <input
                type="number"
                id="weight"
                name="weight"
                className="w-full p-3 border border-gray-300 rounded-lg bg-white text-gray-900 dark:text-white dark:bg-gray-800 dark:border-gray-600 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="وزن بار (تن)"
                onChange={validation.handleChange}
                value={validation.values.weight}
              />
              {validation.touched.weight && validation.errors.weight && (
                <p className="text-red-500 mt-1 text-sm">
                  {validation.errors.weight}
                </p>
              )}
            </div>

            {/* کرایه حمل */}
            <div className="flex flex-col">
              <label
                htmlFor="transportCost"
                className="text-base font-medium mb-2 dark:text-white"
              >
                کرایه حمل:
              </label>
              <input
                type="text"
                id="transportCost"
                name="transportCost"
                className="w-full p-3 border border-gray-300 rounded-lg bg-white text-gray-900 dark:text-white dark:bg-gray-800 dark:border-gray-600 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="کرایه حمل"
                onChange={(e) => {
                  const value = parseFormattedNumber(e.target.value);
                  validation.setFieldValue("transportCost", value);
                }}
                value={formatNumber(validation.values.transportCost)}
              />
              {validation.touched.transportCost &&
                validation.errors.transportCost && (
                  <p className="text-red-500 mt-1 text-sm">
                    {validation.errors.transportCost}
                  </p>
                )}
            </div>
          </div>
        </form>
      </Modal.Body>

      <Modal.Footer className="flex justify-center p-4 border-t dark:border-zink-500">
        <button
          type="button"
          onClick={onSubmit}
          className="px-4 py-2 mt-4 font-bold text-white bg-blue-500 rounded hover:bg-blue-600"
        >
          {isEdit ? "بروز رسانی" : "ثبت اطلاعات"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CarriageFormModal;
